import React, { useContext, useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useParams } from "react-router-dom";
import { AuthContext } from "../../../../config/AuthContext";
import {
    Button,
    Card,
    Col,
    Rate,
    Row,
    Select,
    Table,
    TableProps,
    Tag,
    Typography,
    Statistic,
    Divider,
    FloatButton,
    theme,
    Badge,
    Slider,
    Modal,
    Input,
    Tooltip
} from "antd";
const { TextArea } = Input;
import { ColumnsType } from "antd/es/table";
import { GetAlumnesValidacioByProjectV2, PostValidacioRubrica } from "../../../../dao/abp/GetAlumnesValidacioByProjectV2";
import { GetAlumnesProjecte } from "../../../../dao/abp/GetAlumnesProjecte";
import { FrownOutlined, MehOutlined, SmileOutlined, CalculatorOutlined, CheckCircleOutlined, MessageOutlined } from '@ant-design/icons';
import AvaluacioColors from "../../../../styles/AvaluacioColors";
import { red, green, gold } from "@ant-design/colors";
import { PostProjecteIdAlumneIdAvaluacio } from "../../../../dao/abp/PostProjecteIdAlumneIdAvaluacio";
import { BiRefresh } from "react-icons/bi";

const { Title, Text } = Typography;
const { useToken } = theme;

const InternalCommentModal = ({
                                  visible,
                                  onCancel,
                                  onSave,
                                  initialValue,
                                  title,
                                  loading
                              }: {
    visible: boolean;
    onCancel: () => void;
    onSave: (val: string) => void;
    initialValue: string;
    title: string;
    loading: boolean;
}) => {
    const [value, setValue] = useState(initialValue);

    useEffect(() => {
        if (visible) setValue(initialValue);
    }, [visible, initialValue]);

    return (
        <Modal
            title={title}
            open={visible}
            onOk={() => onSave(value)}
            onCancel={onCancel}
            confirmLoading={loading}
            okText="Guardar"
            cancelText="Cancel·lar"
            destroyOnClose
        >
            <TextArea
                rows={6}
                value={value}
                onChange={(e) => setValue(e.target.value)}
                placeholder="Escriu un comentari..."
                autoFocus
            />
        </Modal>
    );
};

const ProjecteIdValidacions = () => {
    const { isLoggedIn, userId, user } = useContext(AuthContext);
    const { id_projecte, id_grup } = useParams();
    const [grup, setGrups] = useState<any[]>([]);
    const [valdacio, setValidacio] = useState<any[]>([]);
    const [loading, setLoading] = useState(false);
    const [selectedAlumne, setSelectedAlumne] = useState<any>();
    const [filtreAula, setFiltreAula] = useState<number | null>(null);
    const [escalaValidacio, setEscalaValidacio] = useState<number>(5);
    const [commentModalVisible, setCommentModalVisible] = useState(false);
    const [currentCommentItem, setCurrentCommentItem] = useState<any>(null);
    const [recuperacions, setRecuperacions] = useState<any[]>([]);
    const [selectedRecuperacio, setSelectedRecuperacio] = useState<number | undefined>(-1);
    const [ordinariaValidacio, setOrdinariaValidacio] = useState<any[]>([]);
    const { token } = useToken();

    useEffect(() => {
        if (isLoggedIn) {
            checkDades();
        }
    }, [id_projecte]);

    async function checkDades() {
        if (user.tipus === "1" || user.tipus === "0")
            await loadInitialData();
        else
            await loadSingleUsuari();
    }

    async function loadInitialData() {
        setLoading(true);
        if (id_projecte) {
            let alus = [];
            const { GetProjecteRecuperacions } = await import("../../../../dao/abp/ProjecteRecuperacio");
            const recupData = await GetProjecteRecuperacions(id_projecte);
            if (recupData) setRecuperacions(recupData);

            if (id_grup) {
                const grupData = await import("../../../../dao/abp/GetProjecteIdGrupId").then(m => m.GetGrupById(id_grup));
                alus = grupData.alumnes || [];
                if (alus.length > 0 && !selectedAlumne) {
                    setSelectedAlumne(alus[0].id_usuari || alus[0].id);
                    await loadValidacioData(alus[0].id_usuari || alus[0].id, selectedRecuperacio, recupData);
                }
            } else {
                alus = await GetAlumnesProjecte(id_projecte);
            }
            setGrups(alus);
            const pData = await import("../../../../dao/abp/GetProjecteId").then(m => m.GetProjecteId(id_projecte, 0));
            setEscalaValidacio(pData?.escala_validacio || 5);
        }
        setLoading(false);
    }

    async function loadSingleUsuari() {
        setLoading(true);
        const actualIdRecup = selectedRecuperacio === -1 ? undefined : selectedRecuperacio;
        const data = await GetAlumnesValidacioByProjectV2(id_projecte + "", userId, actualIdRecup);
        setValidacio(data);
        
        const { GetProjecteRecuperacions } = await import("../../../../dao/abp/ProjecteRecuperacio");
        const recupData = await GetProjecteRecuperacions(id_projecte + "");
        if (recupData) setRecuperacions(recupData);

        const hist: any[] = [];
        const ordData = await GetAlumnesValidacioByProjectV2(id_projecte + "", userId, undefined);
        hist.push(...ordData);

        if (actualIdRecup !== undefined && recupData) {
            const currentIndex = recupData.findIndex((r: any) => r.id === actualIdRecup);
            if (currentIndex !== -1) {
                for (let i = 0; i < currentIndex; i++) {
                    const recData = await GetAlumnesValidacioByProjectV2(id_projecte + "", userId, recupData[i].id);
                    hist.push(...recData);
                }
            }
        }
        setOrdinariaValidacio(hist);

        const pData = await import("../../../../dao/abp/GetProjecteId").then(m => m.GetProjecteId(id_projecte + "", 0));
        setEscalaValidacio(pData?.escala_validacio || 5);
        setLoading(false);
    }

    async function loadValidacioData(alumneId: string, idRecup?: number, recupList?: any[]) {
        setLoading(true);
        const actualIdRecup = idRecup === -1 ? undefined : idRecup;
        if (alumneId !== undefined) {
            const val = await GetAlumnesValidacioByProjectV2(id_projecte + "", alumneId, actualIdRecup);
            setValidacio(val);

            const listToUse = recupList || recuperacions;
            
            const hist: any[] = [];
            const ordData = await GetAlumnesValidacioByProjectV2(id_projecte + "", alumneId, undefined);
            hist.push(...ordData);

            if (actualIdRecup !== undefined) {
                const currentIndex = listToUse.findIndex(r => r.id === actualIdRecup);
                if (currentIndex !== -1) {
                    for (let i = 0; i < currentIndex; i++) {
                        const recData = await GetAlumnesValidacioByProjectV2(id_projecte + "", alumneId, listToUse[i].id);
                        hist.push(...recData);
                    }
                }
            }
            setOrdinariaValidacio(hist);
        }
        setLoading(false);
    }

    const handleAlumneChange = async (alumneId: string) => {
        setSelectedAlumne(alumneId);
        await loadValidacioData(alumneId, selectedRecuperacio);
    };

    const handleRecuperacioChange = async (idRecup: number | undefined) => {
        setSelectedRecuperacio(idRecup);
        if (selectedAlumne) {
            await loadValidacioData(selectedAlumne, idRecup);
        } else if (user.tipus !== "1" && user.tipus !== "0") {
            await loadValidacioData(userId, idRecup);
        }
    };

    async function rate(ele: any, val: any, commentStr?: string) {
        if (selectedAlumne === null)
            alert("Selecciona alumne");
        else {
            setLoading(true);
            if (user.tipus === "1" || user.tipus === "0") {
                const obs = commentStr !== undefined ? commentStr : ele.observacions;
                const actualIdRecup = selectedRecuperacio === -1 ? undefined : selectedRecuperacio;
                await PostProjecteIdAlumneIdAvaluacio(id_projecte + "", selectedAlumne, ele.modul, ele.ra, val, obs, actualIdRecup);
                await loadValidacioData(selectedAlumne, selectedRecuperacio);
            }
            setLoading(false);
        }
    }

    const handleSliderChange = (ele: any, val: number) => {
        const newData = [...valdacio];
        const index = newData.findIndex(item => item.ra === ele.ra);
        if (index > -1) {
            newData[index].avaluacio = val;
            setValidacio(newData);
        }
    };

    async function rateRubrica(idRubrica: number, val: number, record?: any, commentStr?: string) {
        if (!selectedAlumne) { alert("Selecciona alumne"); return; }
        setLoading(true);
        let obs = "";
        if (record && commentStr === undefined) {
            const aspect = record.rubrica.find((r: any) => r.id === idRubrica);
            if (aspect) obs = aspect.observacions || "";
        } else if (commentStr !== undefined) {
            obs = commentStr;
        }
        const actualIdRecup = selectedRecuperacio === -1 ? undefined : selectedRecuperacio;
        await PostValidacioRubrica(id_projecte + "", selectedAlumne, idRubrica, val, obs, actualIdRecup);
        await loadValidacioData(selectedAlumne, selectedRecuperacio);
        setLoading(false);
    }

    const handleRubricSliderChange = (record: any, aspectId: number, val: number) => {
        const newData = [...valdacio];
        const raIndex = newData.findIndex(item => item.ra === record.ra);
        if (raIndex > -1) {
            const aspIndex = newData[raIndex].rubrica.findIndex((r: any) => r.id === aspectId);
            if (aspIndex > -1) {
                newData[raIndex].rubrica[aspIndex].avaluacio = val;
                setValidacio(newData);
            }
        }
    };

    const openCommentModal = (item: any, isRubric: boolean = false, parentRecord: any = null) => {
        setCurrentCommentItem({ ...item, isRubric, parentRecord });
        setCommentModalVisible(true);
    };

    const handleSaveComment = async (val: string) => {
        if (!currentCommentItem) return;
        setCommentModalVisible(false);
        if (currentCommentItem.isRubric) {
            await rateRubrica(currentCommentItem.id, currentCommentItem.avaluacio, currentCommentItem.parentRecord, val);
        } else {
            await rate(currentCommentItem, currentCommentItem.avaluacio, val);
        }
        setCurrentCommentItem(null);
    };

    const customIcons: Record<number, React.ReactNode> = {
        1: <FrownOutlined />,
        2: <MehOutlined />,
        3: <SmileOutlined />
    };

    const calculateFinalGrade = () => {
        const totalWeight = valdacio.reduce((acc, item) => acc + (item.pes || 0), 0);
        if (totalWeight === 0) return "0.00";

        const recupObj = (selectedRecuperacio && selectedRecuperacio !== -1) ? recuperacions.find(r => r.id === selectedRecuperacio) : null;
        const getApprovedOrdRA = (raId: any) => {
            const ordRA = ordinariaValidacio.find((o: any) => o.ra === raId && o.nota !== undefined && Number(o.nota) >= 5.0);
            return ordRA || null;
        };

        const weightedSum = valdacio.reduce((total, item) => {
            const approvedRA = getApprovedOrdRA(item.ra);
            const nota = approvedRA ? (approvedRA.nota || 0) : (item.nota || 0);
            const pes = item.pes || 0;
            return total + (nota * pes);
        }, 0);

        return (weightedSum / totalWeight).toFixed(2);
    };

    const columnsProfe: ColumnsType<any> = [
        {
            title: 'Mòdul',
            key: 'modul',
            dataIndex: 'modul',
            width: 80,
            render: (e) => <Tag color={AvaluacioColors.colors.color1} style={{ fontWeight: 'bold' }}>{e}</Tag>,
            sorter: (a, b) => a.modul.localeCompare(b.modul),
        },
        {
            title: 'Resultat Aprenentatge',
            key: 'ranom',
            dataIndex: 'ranom',
            render: (e) => <Text strong>{e}</Text>
        },
        {
            title: 'Pes',
            key: 'pes',
            dataIndex: 'pes',
            width: 80,
            align: 'center',
            render: (e, record) => {
                const totalWeight = valdacio.reduce((acc, item) => acc + (item.pes || 0), 0);
                const percentage = totalWeight > 0 ? ((record.pes || 0) / totalWeight * 100) : 0;
                return <Tag color="blue">{Number.isInteger(percentage) ? percentage : percentage.toFixed(2)}%</Tag>;
            }
        },
        {
            title: 'Avaluació',
            key: 'avaluacio',
            dataIndex: 'avaluacio',
            width: 200,
            align: 'center',
            render: (e, ele) => {
                const hasRubrica = ele.rubrica?.length > 0;
                if (hasRubrica) {
                    // avaluacio comes from DB (FLOOR weighted avg computed by post_validacio_rubrica)
                    const dbAval = Number(e) || 0;
                    const avgRounded = Math.round(dbAval * 2) / 2;
                    const colorAvg = dbAval <= (escalaValidacio / 3) ? red[5] : (dbAval <= (escalaValidacio * 2 / 3) ? gold[5] : green[5]);

                    const renderSummary = () => {
                        if (dbAval === 0) return <Tag color="default" style={{ fontSize: 11 }}>Sense avaluar</Tag>;

                        if (escalaValidacio === 10) {
                            return (
                                <div style={{ fontSize: 20, fontWeight: 'bold', color: colorAvg, lineHeight: 1 }}>
                                    {dbAval.toFixed(1)} <small style={{ fontSize: 12, fontWeight: 'normal', opacity: 0.7 }}>/ 10</small>
                                </div>
                            );
                        }

                        if (escalaValidacio === 3) {
                            return (
                                <Rate
                                    disabled
                                    count={3}
                                    character={({ index = 0 }) => customIcons[index + 1]}
                                    value={Math.floor(dbAval)}
                                    style={{ color: colorAvg, fontSize: '22px' }}
                                />
                            );
                        }

                        return (
                            <Rate
                                disabled
                                count={escalaValidacio}
                                value={avgRounded}
                                allowHalf
                                style={{ color: colorAvg, fontSize: '20px' }}
                            />
                        );
                    };

                    return (
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4 }}>
                            {renderSummary()}
                            <Badge
                                count={`${ele.rubrica.length} aspectes`}
                                color="geekblue"
                                style={{ fontSize: 11 }}
                            />
                            <Text type="secondary" style={{ fontSize: 10 }}>Fes clic ↓ per avaluar</Text>
                        </div>
                    );
                }

                const recupObj = (selectedRecuperacio && selectedRecuperacio !== -1) ? recuperacions.find(r => r.id === selectedRecuperacio) : null;
                const getApprovedOrdRA = (raId: any) => {
                    const ordRA = ordinariaValidacio.find((o: any) => o.ra === raId && o.nota !== undefined && Number(o.nota) >= 5.0);
                    return ordRA || null;
                };

                const approvedRA = getApprovedOrdRA(ele.ra);
                const inputDisabled = (user.tipus !== "1" && user.tipus !== "0") || !!approvedRA;

                const displayAvaluacio = approvedRA ? approvedRA.avaluacio : e;
                const displayObservacions = approvedRA ? approvedRA.observacions : ele.observacions;

                // No rubric → direct Rate
                const isNotaDirecta = recupObj?.tipusCalcul === 2;
                const effectiveEscala = (isNotaDirecta && !approvedRA) ? 10 : escalaValidacio;

                const rateColor = displayAvaluacio <= (effectiveEscala / 3) ? red[5] : (displayAvaluacio <= (effectiveEscala * 2 / 3) ? gold[5] : green[5]);

                const renderRate = () => {
                    if (effectiveEscala === 3) {
                        return (
                            <Rate
                                disabled={inputDisabled}
                                onChange={(val) => rate(ele, val)}
                                count={3}
                                character={({ index = 0 }) => customIcons[index + 1]}
                                value={displayAvaluacio}
                                style={{ color: rateColor, fontSize: '22px' }}
                            />
                        );
                    }

                    if (effectiveEscala === 10) {
                        return (
                            <div
                                style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%', padding: '0 10px' }}
                                onClick={(ev) => ev.stopPropagation()}
                            >
                                <Slider
                                    min={0}
                                    max={10}
                                    step={1}
                                    value={displayAvaluacio || 0}
                                    onChange={(val) => handleSliderChange(ele, val)}
                                    onAfterChange={(val) => rate(ele, val)}
                                    disabled={inputDisabled}
                                    style={{ width: '100%', marginBottom: 0 }}
                                    trackStyle={{ backgroundColor: rateColor }}
                                    handleStyle={{ borderColor: rateColor, backgroundColor: rateColor }}
                                />
                                <Text strong style={{ color: rateColor, fontSize: 12 }}>{displayAvaluacio || 0} / 10</Text>
                            </div>
                        );
                    }

                    return (
                        <Rate
                            disabled={inputDisabled}
                            onChange={(val) => rate(ele, val)}
                            count={effectiveEscala}
                            value={displayAvaluacio}
                            style={{ color: rateColor, fontSize: '22px' }}
                        />
                    );
                };

                const rateElement = renderRate();
                const rateWithTooltip = approvedRA ? (
                    <Tooltip title="Bloquejat: aquest RA ja està aprovat en una avaluació prèvia">
                        <div style={{ cursor: 'not-allowed' }}>{rateElement}</div>
                    </Tooltip>
                ) : rateElement;

                return (
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8 }}>
                        {rateWithTooltip}
                        {(user.tipus === "1" || user.tipus === "0") && !approvedRA ? (
                            <Tooltip title={displayObservacions || "Afegir comentari"}>
                                <Button
                                    type="text"
                                    icon={<MessageOutlined />}
                                    onClick={() => openCommentModal(ele, false)}
                                    style={{ color: displayObservacions ? AvaluacioColors.colors.color1 : '#ccc' }}
                                />
                            </Tooltip>
                        ) : (
                            displayObservacions && (
                                <Tooltip title={displayObservacions}>
                                    <MessageOutlined style={{ color: AvaluacioColors.colors.color1, fontSize: 16 }} />
                                </Tooltip>
                            )
                        )}
                    </div>
                );
            }
        },
        {
            title: 'Nota',
            key: 'nota',
            dataIndex: 'nota',
            width: 100,
            align: 'center',
            render: (e, ele) => {
                const recupObj = (selectedRecuperacio && selectedRecuperacio !== -1) ? recuperacions.find(r => r.id === selectedRecuperacio) : null;
                const getApprovedOrdRA = (raId: any) => {
                    const ordRA = ordinariaValidacio.find((o: any) => o.ra === raId && o.nota !== undefined && Number(o.nota) >= 5.0);
                    return ordRA || null;
                };

                const approvedRA = getApprovedOrdRA(ele.ra);
                const displayNota = approvedRA ? approvedRA.nota : e;

                return (
                    <div style={{
                        fontWeight: 'bold',
                        fontSize: '1.1em',
                        color: displayNota >= 5.00 ? green[6] : red[5]
                    }}>
                        {displayNota}
                    </div>
                );
            }
        },
    ];

    const expandedRowRender = (record: any) => {
        if (!record.rubrica || record.rubrica.length === 0) return null;
        return (
            <div style={{ padding: '8px 24px', background: '#fafafa', borderRadius: 8 }}>
                <Text type="secondary" style={{ fontSize: 12, marginBottom: 8, display: 'block' }}>
                    Rúbrica: avalua cada aspecte (la nota del RA es la mitjana ponderada)
                </Text>
                <Table
                    size="small"
                    pagination={false}
                    dataSource={record.rubrica}
                    rowKey="id"
                    columns={[
                        {
                            title: 'Aspecte',
                            dataIndex: 'descripcio',
                            key: 'descripcio',
                        },
                        {
                            title: 'Pes',
                            dataIndex: 'pes',
                            key: 'pes',
                            width: 70,
                            align: 'center' as const,
                            render: (e: any, asp: any) => {
                                const totalWeight = record.rubrica.reduce((acc: number, r: any) => acc + (r.pes || 0), 0);
                                const percentage = totalWeight > 0 ? ((asp.pes || 0) / totalWeight * 100) : 0;
                                return <Tag color="blue">{Number.isInteger(percentage) ? percentage : percentage.toFixed(2)}%</Tag>;
                            }
                        },
                        {
                            title: 'Puntuació',
                            dataIndex: 'avaluacio',
                            key: 'avaluacio',
                            width: 220,
                            align: 'center' as const,
                            render: (e: any, asp: any) => {
                                // Use per-aspect escala_validacio if available (from DB JSON), else fall back to project scale
                                const aspEscala = asp.escala_validacio || escalaValidacio;

                                const recupObj = (selectedRecuperacio && selectedRecuperacio !== -1) ? recuperacions.find(r => r.id === selectedRecuperacio) : null;
                                const getApprovedOrdRA = (raId: any) => {
                                    const ordRA = ordinariaValidacio.find((o: any) => o.ra === raId && o.nota !== undefined && Number(o.nota) >= 5.0);
                                    return ordRA || null;
                                };

                                const approvedRA = getApprovedOrdRA(record.ra);
                                const inputDisabled = (user.tipus !== "1" && user.tipus !== "0") || !!approvedRA;

                                let displayAvaluacio = e;
                                let displayObservacions = asp.observacions;
                                if (approvedRA) {
                                    const ordAsp = approvedRA.rubrica?.find((r: any) => r.id === asp.id || r.descripcio === asp.descripcio);
                                    if (ordAsp) {
                                        displayAvaluacio = ordAsp.avaluacio;
                                        displayObservacions = ordAsp.observacions;
                                    }
                                }

                                const aspColor = displayAvaluacio <= (aspEscala / 3) ? red[5] : (displayAvaluacio <= (aspEscala * 2 / 3) ? gold[5] : green[5]);

                                const renderAspRate = () => {
                                    if (aspEscala === 10) {
                                        return (
                                            <div
                                                style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '0 10px', flex: 1 }}
                                                onClick={(ev) => ev.stopPropagation()}
                                            >
                                                <Slider
                                                    min={0}
                                                    max={10}
                                                    step={1}
                                                    value={displayAvaluacio || 0}
                                                    onChange={(val) => handleRubricSliderChange(record, asp.id, val)}
                                                    onAfterChange={(val) => rateRubrica(asp.id, val, record)}
                                                    disabled={inputDisabled}
                                                    style={{ flex: 1 }}
                                                    trackStyle={{ backgroundColor: aspColor }}
                                                    handleStyle={{ borderColor: aspColor, backgroundColor: aspColor }}
                                                />
                                                <Text strong style={{ color: aspColor, minWidth: 35 }}>{displayAvaluacio || 0}/10</Text>
                                            </div>
                                        );
                                    }

                                    if (aspEscala === 3) {
                                        return (
                                            <Rate
                                                disabled={inputDisabled}
                                                count={3}
                                                character={({ index = 0 }) => customIcons[index + 1]}
                                                value={displayAvaluacio}
                                                onChange={(val) => rateRubrica(asp.id, val, record)}
                                                style={{ color: aspColor, fontSize: '22px' }}
                                            />
                                        );
                                    }

                                    return (
                                        <Rate
                                            disabled={inputDisabled}
                                            count={aspEscala}
                                            value={displayAvaluacio}
                                            onChange={(val) => rateRubrica(asp.id, val, record)}
                                            style={{
                                                color: aspColor,
                                                fontSize: '18px'
                                            }}
                                        />
                                    );
                                };

                                const aspRateElement = renderAspRate();
                                const aspRateWithTooltip = approvedRA ? (
                                    <Tooltip title="Bloquejat: aquest RA ja està aprovat en una avaluació prèvia">
                                        <div style={{ cursor: 'not-allowed' }}>{aspRateElement}</div>
                                    </Tooltip>
                                ) : aspRateElement;

                                return (
                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8 }}>
                                        {aspRateWithTooltip}
                                        {(user.tipus === "1" || user.tipus === "0") && !approvedRA ? (
                                            <Tooltip title={displayObservacions || "Afegir comentari"}>
                                                <Button
                                                    type="text"
                                                    icon={<MessageOutlined />}
                                                    onClick={() => openCommentModal(asp, true, record)}
                                                    style={{ color: displayObservacions ? AvaluacioColors.colors.color1 : '#ccc' }}
                                                />
                                            </Tooltip>
                                        ) : (
                                            displayObservacions && (
                                                <Tooltip title={displayObservacions}>
                                                    <MessageOutlined style={{ color: AvaluacioColors.colors.color1, fontSize: 16 }} />
                                                </Tooltip>
                                            )
                                        )}
                                    </div>
                                );
                            }
                        }
                    ]}
                />
            </div>
        );
    };

    const tableProps: TableProps<any> = {
        loading,
        size: 'middle'
    };

    return (
        <div style={{ padding: '24px', maxWidth: 1600, margin: '0 auto' }}>
            <Title level={2} style={{ marginBottom: 24, color: AvaluacioColors.colors.color1 }}>
                <CheckCircleOutlined /> Validació de Projecte
            </Title>

            {recuperacions.length > 0 && (
                <Card bordered={false} style={{ marginBottom: 24, borderRadius: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.05)' }}>
                    <Row align="middle" justify="space-between">
                        <Col>
                            <Text strong style={{ fontSize: 16 }}>Avaluació Activa:</Text>
                        </Col>
                        <Col>
                            <Select
                                value={selectedRecuperacio}
                                onChange={handleRecuperacioChange}
                                style={{ width: 300 }}
                                options={[
                                    { value: -1, label: 'Avaluació Ordinària' },
                                    ...recuperacions.map(r => ({
                                        value: r.id,
                                        label: `Recuperació: ${r.nom}`
                                    }))
                                ]}
                            />
                        </Col>
                    </Row>
                </Card>
            )}

            <Row gutter={[24, 24]}>
                <Col xs={24} lg={18}>
                    <Card
                        title="Items d'Avaluació"
                        bordered={false}
                        style={{ boxShadow: '0 4px 12px rgba(0,0,0,0.05)', borderRadius: 12 }}
                    >
                        {(user.tipus === "0" || user.tipus === "1") && (
                            <div style={{ marginBottom: 24, padding: 16, backgroundColor: '#f5f5f5', borderRadius: 8 }}>
                                <Row gutter={16} align="middle">
                                    {!id_grup && (
                                        <Col flex="auto">
                                            <Text strong style={{ display: 'block', marginBottom: 8 }}>Filtrar per Aula:</Text>
                                            <Select
                                                style={{ width: '100%' }}
                                                placeholder="Totes les aules"
                                                allowClear
                                                onChange={(val) => {
                                                    setFiltreAula(val);
                                                    setSelectedAlumne(undefined);
                                                    setValidacio([]);
                                                }}
                                                options={Array.from(new Map(grup?.map(a => [a.id_aula, a.aula_nom])).entries()).filter(([id]) => id !== undefined).map(([id, nom]) => ({ value: id as number, label: nom as string }))}
                                            />
                                        </Col>
                                    )}
                                    <Col flex="auto">
                                        <Text strong style={{ display: 'block', marginBottom: 8 }}>Seleccionar Alumne {id_grup ? 'del Grup' : ''}:</Text>
                                        <Select
                                            style={{ width: '100%' }}
                                            value={selectedAlumne}
                                            onChange={handleAlumneChange}
                                            placeholder="Buscar alumne..."
                                            showSearch
                                            filterOption={(input, option) =>
                                                (option?.label as string || '').toLowerCase().includes(input.toLowerCase())
                                            }
                                            options={grup?.filter(a => !filtreAula || String(a.id_aula) === String(filtreAula)).map(a => ({
                                                value: id_grup ? (a.id_usuari || a.id) : a.id,
                                                label: `${a.nom} ${a.cognoms}`
                                            }))}
                                        />
                                    </Col>
                                </Row>
                            </div>
                        )}

                        <Table
                            {...tableProps}
                            columns={columnsProfe}
                            dataSource={valdacio?.sort((a: any, b: any) => a.modul.localeCompare(b.modul))}
                            rowKey="ra"
                            pagination={false}
                            rowClassName={() => 'editable-row'}
                            expandable={{
                                expandedRowRender,
                                rowExpandable: (record) => record.rubrica?.length > 0,
                                expandRowByClick: true,
                            }}
                        />
                    </Card>
                </Col>

                <Col xs={24} lg={6}>
                    <Card
                        title="Resum de Qualificació"
                        bordered={false}
                        style={{
                            boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
                            borderRadius: 12,
                            textAlign: 'center'
                        }}
                    >
                        <Statistic
                            title="Nota Final Calculada"
                            value={calculateFinalGrade()}
                            precision={2}
                            valueStyle={{
                                color: parseFloat(calculateFinalGrade()) >= 5 ? green[6] : red[5],
                                fontSize: '3rem',
                                fontWeight: 'bold'
                            }}
                            prefix={<CalculatorOutlined />}
                        />
                        <Divider />
                        <div style={{ textAlign: 'left' }}>
                            <Text type="secondary">
                                La nota es calcula mitjançant la mitjana ponderada dels pesos de cada ítem avaluat.
                            </Text>
                        </div>
                    </Card>
                </Col>
            </Row>

            {!loading && <FloatButton
                shape="circle"
                onClick={() => checkDades()}
                style={{ right: 24, bottom: 24 }}
                type="primary"
                icon={<BiRefresh />}
            />}
            <InternalCommentModal
                visible={commentModalVisible}
                onCancel={() => setCommentModalVisible(false)}
                onSave={handleSaveComment}
                initialValue={currentCommentItem?.observacions || ""}
                title={currentCommentItem?.isRubric ? "Comentari (Aspecte de Rúbrica)" : "Comentari (RA)"}
                loading={loading}
            />
        </div>
    );
};

export default ProjecteIdValidacions;
